import {BenjiKIVOutroView} from "../base/BenjiKIVOutroView";

/**
 * Created by Jerker Nord on 2021-09-25.
 */

export class BenjiKIVFreeSpinOutroView extends BenjiKIVOutroView {

    constructor() {
        super();
        this.name = "BenjiKIVFreeSpinOutroView";
    }

    protected getOutroContainerPos():PIXI.Point {
        return new PIXI.Point(360, 60);
    }

    protected getCountUpYPos() {
        return 340;
    }
}